import {AnticipatorEvents, AnticipatorModule} from '@gongxigames/framework/slot';
import {WolfHaven} from 'com/gongxigames/math/wolfhaven/engine/WolfHaven';

export class GameAnticipatorModule extends AnticipatorModule {
    protected onSpinResultReceived(): void {
        this._anticipatedReels = [];

        if (!this.isAutoplaySkip()) {
            this.initAnicipatedList(this.logic.spinData.symbolIds);
        }
        this.eventManager.emit(AnticipatorEvents.ANTICIPATION_REELS_RESULT_RECEIVED, this._anticipatedReels);
    }

    protected initAnicipatedList(symbols: number[][]): void {
        let anticipatedSymbolsFound = 0;

        symbols.forEach((reel, reelIndex) => {
            anticipatedSymbolsFound >= this.getSymbolsAmountForFreeSpins() - 1 && this.addToAnticipatedReelsList(reelIndex);
            reel.forEach(symbol => this.isSymbolAnticipated(symbol) && anticipatedSymbolsFound++);
        });
    }

    protected isSymbolAnticipated(symbol: number): boolean {
        return symbol === WolfHaven.Scatter;
    }
}
